module.exports = __webpack_public_path__ + "static/banner_square-c6bd1ff00d4da7f9d8610408e39dffcc.jpg";